"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var image_utils_1 = require("./image/image.utils");
var srcSetTransform = function (w, transforms) {
    return transforms ? "w_" + w + "," + transforms : "w_" + w;
};
var Image = /** @class */ (function () {
    function Image() {
    }
    /**
     * Create img props for srcset. Spread return into img component
     * Should be run with useMemo for better performance
     */
    Image.srcSet = function (image, width, height, _a) {
        var _this = this;
        if (height === void 0) { height = width; }
        var _b = _a === void 0 ? {} : _a, _c = _b.transforms, transforms = _c === void 0 ? "" : _c, _d = _b.disableFullWidth, disableFullWidth = _d === void 0 ? false : _d;
        if (!image)
            return { src: "#", width: width, height: height, alt: "No image" };
        transforms = transforms ? transforms + ",h_" + height : "h_" + height;
        if (!transforms.match(/c_/))
            transforms += ",c_pad";
        var set = image_utils_1.getImageSet(width);
        var src = this.createUrl({ image: image });
        var loading = image.lazyLoad ? "lazy" : undefined;
        var srcSet = set
            .map(function (x) {
            return _this.createUrl({
                image: image,
                transforms: srcSetTransform(x.width, transforms),
            }) + " " + x.width + "w";
        })
            .join(",");
        var sizes = set
            .map(function (x, i) {
            var min = set[i - 1] ? set[i - 1].maxWidth : 0;
            var max = x.maxWidth;
            return max
                ? "(min-width: " + min + "px) and (max-width: " + max + "px) " + x.width + "px"
                : "(min-width: " + min + "px) " + x.width + "px";
        })
            .join(",");
        var ret = {
            src: src,
            srcSet: srcSet,
            sizes: sizes,
            loading: loading,
            alt: image.alt,
            width: width,
            height: height,
        };
        if (!disableFullWidth)
            ret.style = { width: "100%", height: "auto" };
        return ret;
    };
    /**
     * Create CSS Media queries for background images and styled-components css
     * Should be run with useMemo for better performance
     */
    Image.css = function (image, size, transforms) {
        var _this = this;
        var set = image_utils_1.getImageSet(size);
        return set.map(function (x, i) {
            var url = _this.createUrl({
                image: image,
                transforms: srcSetTransform(x.width, transforms),
            });
            var url2x = _this.createUrl({
                image: image,
                transforms: srcSetTransform(x.width2x, transforms),
            });
            var min = set[i - 1] ? set[i - 1].maxWidth : 0;
            var max = x.maxWidth;
            return max
                ? "\n        @media all and (min-width: " + min + "px) and (max-width: " + max + "px) {\n          background-image: url(\"" + url + "\");\n        }\n        @media all and (min-width: " + min + "px) and (max-width: " + max + "px)\n        and (-webkit-min-device-pixel-ratio: 2) {\n          background-image: url(\"" + url2x + "\");\n        }\n      "
                : "\n        background-image: url(\"" + url + "\");\n        @media all and (min-width: " + min + "px) and (-webkit-min-device-pixel-ratio: 2) {\n          background-image: url(\"" + url2x + "\");\n        }\n      ";
        }).join("\n    ");
    };
    Image.createUrl = function (opts) {
        var url = constants_1.PLACEHOLDER_IMAGE.url;
        var cropOps = [];
        if (!opts.image) {
            return url;
        }
        else if (typeof opts.image.url === "string") {
            url = opts.image.url;
        }
        if (url.endsWith(".gif")) {
            return url;
        }
        if (opts.image.crop) {
            var crop = opts.image.crop;
            cropOps.push("x_" + crop.x + ",y_" + crop.y + ",w_" + crop.w + ",h_" + crop.h + ",c_crop");
        }
        if (opts.transforms || opts.image.transforms) {
            var transforms = opts.transforms || opts.image.transforms;
            if (opts.image.focus &&
                typeof opts.image.focus.x === "number" &&
                transforms.includes("c_fill")) {
                transforms = transforms + ",g_xy_center,x_" + opts.image.focus.x + ",y_" + opts.image.focus.y;
            }
            cropOps.push(transforms);
        }
        if (!opts.dontAutoFormat && !opts.fileType && !url.endsWith(".svg")) {
            cropOps.push("f_auto");
        }
        if (cropOps.length > 0) {
            url = url.replace(/\/upload\/([^\/]*)/, "/upload/" + cropOps.join("/"));
        }
        if (opts.fileType) {
            url = url.substr(0, url.lastIndexOf(".")) + "." + opts.fileType;
        }
        return url;
    };
    return Image;
}());
exports.default = Image;
//# sourceMappingURL=Image.js.map